import ChangesInProgressWarningDialog from './ChangesInProgressWarningDialog';

export default ChangesInProgressWarningDialog;
